import useTranslate from "@app/_hooks/useTranslate";
import {
  Accordion,
  AccordionContent,
  AccordionHeader,
  AccordionItem,
  AccordionTrigger,
} from "@ui/accordion";
import { Dialog, DialogTrigger } from "@ui/dialog";
import { Paragraph } from "@ui/paragraph";
import type { DELIVERY_ITEM, StockStatusProps } from "../Stock.types";
import { stockStatusVariants } from "../Stock.utils";
import StockIndicator from "./StockIndicator";

export default function DeliveryItem({
  status,
  config,
}: {
  status: DELIVERY_ITEM;
  config: StockStatusProps;
}) {
  const t = useTranslate();
  const { type, className, stockInfo } = config;

  const {
    root: rootSlot,
    trigger: triggerSlot,
    explanation: explanationSlot,
  } = stockStatusVariants({ type });

  if (type === "plp") return null;

  if (type === "pdp") {
    return (
      <Dialog>
        <Accordion className="text-sm" type="single" collapsible>
          <AccordionItem value={type}>
            <AccordionHeader asChild>
              <div className={rootSlot()}>
                <StockIndicator status={status.code} />
                <span className="inline-block">{t("availableForOrder")}</span>
                <AccordionTrigger>{t("moreInfo")}</AccordionTrigger>
              </div>
            </AccordionHeader>
            <AccordionContent>
              <Paragraph className={explanationSlot()}>
                {t("deliveryItemExplanation")}{" "}
                {stockInfo && (
                  <DialogTrigger className={triggerSlot({ kind: "dialog" })}>
                    {t("readMore")}
                  </DialogTrigger>
                )}
              </Paragraph>
            </AccordionContent>
          </AccordionItem>
        </Accordion>
        {stockInfo}
      </Dialog>
    );
  }

  return (
    <div className={rootSlot({ className })}>
      <StockIndicator status={status.code} />
      <span className="inline-block">{t("madeToOrder")}</span>
    </div>
  );
}
